import { utils } from './utils.js';

class Map {
    constructor() {
    }
    init() {

        let self = this;

        self.markers = [];
        self.infoWindows = [];

        let container = document.querySelector('.map-container');
        if ( container == null ) {
            return;
        }

        // see if we have data to plot

        let contactCard = document.querySelector('.right-content .contact-card');
        let cards   = ( contactCard == null )
                    ? document.querySelectorAll('#primary .card-list .card')
                    : document.querySelectorAll('.contact-card');

        let map = new google.maps.Map(container, {
            scrollwheel: true,
            mapTypeControl: true,
            draggableCursor: 'default',
            clickableIcons: true,
            styles: self.getMapStyles(),
            mapTypeControl: false,
            streetViewControl: false
        });

        let iconBase = Site.site_url + '/wp-content/themes/covenantcare/assets/';

        Array.prototype.forEach.call(cards, function(el, i) {

            let data = el.getAttribute('data-map');
                data = JSON.parse(data);

            if ( typeof data.address !== 'undefined' ) {

                let latLng  = new google.maps.LatLng( data.lat, data.lng );
                let infoWindowContent = '<div class="infowindow">'+
                    '<div class="infowindow-content">'+
                        '<h5>' + data.name + '</h5>' +
                    '</div>'+
                '</div>';
                let infoWindow = new google.maps.InfoWindow({
                    content: infoWindowContent,
                    animation: false,
                    disableAutoPan: true
                });
                self.infoWindows.push( infoWindow );

                let icon = {
                    url: iconBase + 'map-marker.png'
                    // scaledSize: new google.maps.Size(120, 126), // scaled size
                    // origin: new google.maps.Point(0, -30), // origin
                    // anchor: new google.maps.Point(60, 126) // anchor
                }
                let marker  = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    title: data.name,
                    draggable: false,
                    // animation: google.maps.Animation.DROP,
                    icon: icon
                });

                marker.addListener('click', function() {
                    self.closeInfoWindows();
                    // map.setCenter( marker.position );
                    // marker.setMap(map);
                    infoWindow.open(map, marker);
                });

                self.markers.push( marker );
            }

        });

        let bounds          = new google.maps.LatLngBounds();
        let markers_count   = self.markers.length;

        if ( markers_count == 1 ) {

            // set centre and zoom
            var currentPosition = self.markers[0].getPosition();
            // bounds.extend(currentPosition);
            // map.fitBounds(bounds);  // auto-zoom
            // map.panToBounds(bounds);// auto-center
            map.setCenter(currentPosition);
            map.setZoom(14);

        } else {
            // otherwise attempt to fit all markers
            for( var i = 0; i < markers_count; i++ ) {
                bounds.extend(self.markers[i].getPosition());
            }
            map.fitBounds(bounds);
        }

    }

    closeInfoWindows() {

        var self = this;
        for (var i=0;i<self.infoWindows.length;i++) {
            self.infoWindows[i].close();
        }
    }

    getMapStyles() {
        return [
            {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#001d51"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#001d51"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#001d51"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 65
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": "50"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d8d8d8"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "30"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d8d8d8"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "40"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffff00"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -97
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#00add0"
                    },
                    {
                        "lightness": "0"
                    },
                    {
                        "saturation": "0"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -100
                    }
                ]
            }
        ];
    }

} // class Map

// Singleton
export let map = new Map();